import { Link } from 'react-router-dom';
import { ChevronRight, Link as LinkIcon, Mail, QrCode, ShieldCheck } from 'lucide-react';
import Header from '../components/layout/Header';

const modes = [
  { icon: LinkIcon, title: 'Vérifier un lien', text: 'Collez une URL reçue par WhatsApp, SMS ou email.', to: '/analyze/url', bg: 'bg-blue-100', color: 'text-accent-blue' },
  { icon: Mail, title: 'Vérifier un message', text: "Analysez un expéditeur, des en-têtes ou un message suspect.", to: '/analyze/message', bg: 'bg-amber-100', color: 'text-amber-500' },
  { icon: QrCode, title: 'Scanner un QR code', text: 'Utilisez la caméra ou importez une photo de QR code.', to: '/analyze/qr', bg: 'bg-gray-100', color: 'text-brand-navy' },
];

export default function AnalyzeHubPage() {
  return (
    <div className="page-container">
      <Header />
      <section className="mx-4 mt-6">
        <h1 className="text-2xl md:text-3xl font-extrabold text-brand-navy">Que voulez-vous analyser ?</h1>
        <p className="mt-2 text-sm text-text-muted leading-relaxed">Choisissez le type de menace que vous voulez vérifier. SENTINELLE vous guide étape par étape.</p>
      </section>

      <section className="mx-4 mt-6 grid gap-4 md:grid-cols-3">
        {modes.map(({ icon: Icon, title, text, to, bg, color }) => (
          <Link key={title} to={to} className="card min-h-[140px] flex flex-col active:scale-95 transition-transform">
            <span className={`w-12 h-12 rounded-xl ${bg} ${color} flex items-center justify-center`}><Icon className="w-6 h-6" /></span>
            <h2 className="mt-4 font-bold text-text-primary">{title}</h2>
            <p className="mt-1 text-sm text-text-muted leading-relaxed flex-1">{text}</p>
            <span className="mt-3 text-accent-blue font-medium flex items-center gap-1">Commencer <ChevronRight className="w-4 h-4" /></span>
          </Link>
        ))}
      </section>

      <section className="mx-4 mt-6 card bg-brand-navy text-white flex gap-3 items-start">
        <ShieldCheck className="w-6 h-6 flex-shrink-0" />
        <p className="text-sm leading-relaxed text-white/80">Vos analyses restent confidentielles. Les fichiers QR importés servent uniquement à la vérification.</p>
      </section>
    </div>
  );
}
